import React from "react"
import ContentLoader from "react-content-loader"

const PreloaderProductInfo = (props) => (
  <ContentLoader
  speed={2}
  width={1000}
  height={300}
  viewBox="0 0 1000 300"
  backgroundColor="#f3f3f3"
  foregroundColor="#832626"
  {...props}
>
  {/* <rect x="4" y="8" rx="3" ry="3" width="7" height="288" /> */}
  {/* <rect x="6" y="289" rx="3" ry="3" width="669" height="8" /> */}
  {/* <rect x="670" y="9" rx="3" ry="3" width="6" height="285" /> */}
  <rect x="650" y="42" rx="16" ry="16" width="274" height="216" />  {/* Rectangle*/}
  <rect x="0" y="90" rx="3" ry="3" width="478" height="6" />
  <rect x="8" y="110" rx="3" ry="3" width="402" height="7" />
  <rect x="2" y="130" rx="3" ry="3" width="478" height="6" />
  <rect x="12" y="150" rx="3" ry="3" width="402" height="7" />
  <rect x="1" y="170" rx="3" ry="3" width="478" height="6" />
  <rect x="0" y="190" rx="3" ry="3" width="478" height="6" />
  <rect x="8" y="210" rx="3" ry="3" width="402" height="7" />
  {/* <rect x="5" y="8" rx="3" ry="3" width="669" height="7" /> */}
  <rect x="2" y="254" rx="14" ry="14" width="200" height="32" />{/* Cat*/}
  <rect x="225" y="254" rx="14" ry="14" width="200" height="32" />{/* Cat*/}
  <rect x="0" y="41" rx="3" ry="3" width="300" height="29" /> {/* Title*/}
</ContentLoader> 
)

export default PreloaderProductInfo;